export const toTableRowItems = (items: MetiFile[]) =>
  items.map((item: any) => ({
    id: item.id,
    batch: item.batch || '',
    defectQuantity: item.defectQuantity || '',
    deviation: item.deviation || '',
    dlc: item.dlc,
    driverCode: item.driverCode || '',
    expectedQuantity: item.expectedQuantity || '',
    metiBatch: item.metiBatch || '',
    metiDlc: item.metiDlc || '',
    metiError: item.metiError || '',
    metiOrderId: item.metiOrderId || '',
    metiOrderStatus: item.metiOrderStatus || '',
    metiQuantity: item.metiQuantity || '',
    metiResultCode: item.metiResultCode || '',
    metiSupplier: item.metiSupplier || '',
    missingQuantity: item.missingQuantity || '',
    originalOrderId: item.originalOrderId || '',
    prodCode: item.prodCode || '',
    prodName: item.prodName || '',
    receivedQuantity: item.receivedQuantity || '',
    stockQuantity: item.stockQuantity || '',
    transportCode: item.transportCode || '',
    truckNumber: item.truckNumber || '',
    unitCode: item.unitCode || ''
  }))
